<app-banner></app-banner>
<div class="firstTitle gridSecRow">
    <h4 class="title font-bold">Over 350 brands to choose from</h4>
</div>
<brand-carousel [brands]="brands()" [squared]="true" [interval]="5000"></brand-carousel>
<div class="buttonDiv" style="margin-bottom: 30px;">
    <button id="brandButton" (click)="seeBrands()" class="homeButton font-semibold">
        <mat-icon>chevron_right</mat-icon>
        <span>See all brands</span>
        <mat-icon>chevron_left</mat-icon>
    </button>
    </div>
<div class="greySec">
    <div class="rowTitle gridSecRow">
        <h4 class="title font-extrabold">How it works</h4>
    </div>
    @defer{
        <div id="howitworks" class="row fadeIn">
            <div class="col-3">
                <img id="image1" src="/old/homev2/cashregister.svg" alt="Cash Register">
                <h5 class="textTitle font-bold">1. Visit the store or restaurant</h5>
                <div class="textDesc">
                    <p class="ptext">When asking for the bill or while at the cashpoint, select the offer you want to use, click on <span class="font-semibold">Get Code</span> and press <span class="font-semibold">Use Now</span> to confirm.</p>
                </div>
            </div>
            <div class="col-3">
                <img id="image2" src="/old/homev2/qrcode.svg" alt="QR Code">
                <h5 class="textTitle">2. Scan the QR code</h5>
                <div class="textDesc">
                    <p class="ptext">Scan the code provided, or use the 4-digit pin code number provided by the cashier, to validate your discount. </p>
                </div>
            </div>
            <div class="col-3">
                <img id="image3" src="/old/homev2/savings.svg" alt="Savings">
                <div class="textDesc">
                    <h5 class="textTitle">3. Enjoy your savings!</h5>
                </div>
                <p class="ptext">Once validated, show the final code on the black screen to the cashier, who will then apply your discount. </p>
            </div>
        </div>
    <div id="gridSec">
        <div class="row gridSecRow">
            <h4 class="title">What you get</h4>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="context">
                    <img class="gridImg" src="/old/homev2/influencer-top-left.webp" alt="Customer enjoying over 350 brands including springfield"/>
                    <p class="textTitle font-semibold gridContent">A selection of 350+ brands</p>
                    <p class="ptext gridContent">On food, fashion, retail, sports and fitness, pet shops, toy shops and so much more!</p>
                </div>
            </div>
            <div class="col-6">
                <div class="context">
                    <img class="gridImg" src="/old/homev2/influencer-top-right.webp" alt="Customer saving cash from darmanin group outlets"/>
                    <p class="textTitle font-semibold gridContent">Instantly saved cash</p>
                    <p class="ptext gridContent">No need to gather points, cloudigo users simply get their discounts and save immediately.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="context">
                    <img class="gridImg" src="/old/homev2/influencer-bottom-left.webp" alt="Customer enjoying offers from eeetwell"/>
                    <p class="textTitle font-semibold gridContent">Free offers</p>
                    <p class="ptext gridContent">You can get up to 10% OFF from brands on cloudigo, simply by downloading the app for free.</p>
                </div>
            </div>
            <div class="col-6">
                <div class="context">
                    <img class="gridImg" src="/old/homev2/influencer-bottom-right.webp" alt="Customer using the app for premium offers"/>
                    <p class="textTitle font-semibold gridContent">Premium offers</p>
                    <p class="ptext gridContent">With cloudigo premium, you will have access to 1000+ discounts of up to 50% OFF!</p>
                </div>
            </div>
        </div>
    </div>
    <app-video-banner title="Learn how cloudigo works" subtitle="Watch this short video and learn how you can save on a daily basis." videoUrl="https://images.cloudigo.app/campaigns/home_bruno_day_of_discounts.mp4"></app-video-banner>
    <div class="greySec">
        <div class="row gridSecRow">
            <h4 class="title">Join thousands of members saving money</h4>
        </div>
        <div class="reviews">
            @for(review of reviews; let i = $index; track i){
                <div class="review-container">
                    <p class="textTitle">{{review.reviewer}}</p>
                    <p class="reviewContent" style="font-size: 17px;">{{review.message}}</p>
                </div>
            }
        </div>
    </div>
    }
</div>